import { Form, Formik } from "formik";
import { motion } from "framer-motion";
import Input from "../../../../components/common/inputs/Input";
import Select from "../../../../components/common/inputs/Select";
import { putApi } from "../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/toastify-message/ToastifyMessage";
import { useContext } from "react";
import { context } from "../../../../context/context";

function Validation({ data, reGetData }) {
  const { utils } = useContext(context);

  const formHandler = async (values) => {
    const path = `/admin/loans/${data?._id}`;
    const body = {
      ...values,
      amount: Number(values?.amount),
      remainingGuaranteeLimit: Number(values?.remainingGuaranteeLimit),
      guaranteeLimit: Number(values?.guaranteeLimit),
      promissoryNote: Number(values?.promissoryNote),
      installmentAmount: Number(values?.installmentAmount),
    };
    try {
      await putApi({ path, body });
      successMessage("اطلاعات کاربر با موفقیت ویرایش شد.");
      reGetData();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white dark:bg-[#060d26] shadow-sm p-6"
    >
      <h3 class="mb-4 text-lg font-medium leading-none text-gray-900 dark:text-white">
        اعتبار سنجی{" "}
      </h3>
      <Formik
        enableReinitialize
        initialValues={{
          amount: data?.amount || "",
          remainingGuaranteeLimit: data?.remainingGuaranteeLimit || "",
          guaranteeLimit: data?.guaranteeLimit || "",
          promissoryNote: data?.promissoryNote || "",
          installmentAmount: data?.installmentAmount || "",
          creditType: data?.creditType || "",
        }}
        onSubmit={formHandler}
      >
        {() => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-6 md:grid-cols-2">
                <Input
                  name="amount"
                  placeholder="مبلغ وام"
                  label="مبلغ وام"
                  type="text"
                />
                <Input
                  name="guaranteeLimit"
                  placeholder="سقف ضمانت"
                  label="سقف ضمانت"
                  type="text"
                />
                <Input
                  name="remainingGuaranteeLimit"
                  placeholder="مانده سقف ضمانت"
                  label="مانده سقف ضمانت"
                  type="text"
                />
                <Input
                  name="promissoryNote"
                  placeholder="مبلغ سفته"
                  label="مبلغ سفته"
                  type="text"
                />
                <Input
                  name="installmentAmount"
                  placeholder="مبلغ قسط"
                  label="مبلغ قسط"
                  type="text"
                />
                <Select
                  name="creditType"
                  placeholder="وضعیت اعتبار سنجی"
                  label="وضعیت اعتبار سنجی"
                >
                  <option>انتخاب وضعیت</option>

                  {utils?.CREDIT_TYPE_VALUES?.length
                    ? utils?.CREDIT_TYPE_VALUES.map((item) => {
                        return (
                          <option value={item?.value}>{item?.name}</option>
                        );
                      })
                    : null}
                </Select>
              </div>
              <button
                type="submit"
                class="mt-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                ثبت اطلاعات
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </motion.div>
  );
}

export default Validation;
